import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Routes } from '@/router';
import { RewardsPageLoadEvent } from '@/services/analytics/events/rewards-page-load-event';

@Component({
  name: 'CmgReferralLandingPage',
})
export default class CmgReferralLandingPage extends Vue {
  get cref(): string {
    return new URLSearchParams(window.location.search).get('cref') || '';
  }

  get medallionImageSrc(): string {
    return this.$appStore.state.cms.images.logos.medallionReward.default;
  }

  get title(): string {
    return `You're Invited!`;
  }

  get bodyText(): string {
    return `Join Chipotle Rewards to order your favorites even faster. Earn 100 extra points after placing your first order over $10 by signing up using this link.`;
  }

  get isRewardsReferralProgramEnabled(): boolean {
    return this.$appStore.state.featureFlags.featureFlags.isRewardsReferralProgramEnabled;
  }

  async mounted(): Promise<void> {
    await this.$services.featureFlags.waitForSplitReady();

    if (!this.isRewardsReferralProgramEnabled) {
        window.location.replace(`${window.location.origin}/referrals`);
        return;
    }

    if(this.cref) {
            this.$services.analytics.applyOne({
                account: {
                    rewardsReferralInviteViewed: { value: 1 }
                }
            })
            this.$services.analytics.send(new RewardsPageLoadEvent('referral:guest'))
          } 

    this.$services.ui.setReferrerCustomerIdHash(this.cref);
  }

  onCreateAccountClick() {
    this.$router.push({ name: Routes.CreateAccount, query: { cref: this.cref } });
  }

  onSignInClick() {
    this.$router.push({ name: Routes.SignIn, query: { cref: this.cref } });
  }
}
